<!--
 * @Author: your name
 * @Date: 2021-04-08 22:02:30
 * @LastEditTime: 2023-11-02 22:18:44
 * @LastEditors: yanglq-PC 61739363@qq.com
 * @Description: In User Settings Edit
 * @FilePath: \web_page\src\page\GoodList.vue
-->
<template>
    <div class="layout">
        <MainHeader />
        <MainNav />
        <div class="main_box">
            <el-main>
                <el-breadcrumb separator-class="el-icon-arrow-right">
                    <el-breadcrumb-item :to="{ path: '/' }">
                        首頁
                    </el-breadcrumb-item>
                    <el-breadcrumb-item :to="`/Good?id=${add_form.id}`">
                        商品詳情
                    </el-breadcrumb-item>
                </el-breadcrumb>
                <div v-if="goods_info" class="good_con">
                    <div class="left">
                        <div class="thum_box">
                            <img class="good_img" :src="goods_info.image" />
                        </div>
                        <div class="clear"></div>
                    </div>
                    <div class="right">
                        <div class="title top_brand">
                            {{ `【${goods_info.brand_name}】` }}
                        </div>
                        <div class="title">
                            {{ goods_info.name }}
                        </div>
                        <div class="price_box">
                            <div v-if="user_data == null" class="no_login">
                                <div class="left">
                                    <div class="top"><span>₩</span>{{ amountFormatte(Math.floor(goods_info.price)) }}</div>
                                    <div class="bottom">
                                        <div class="item">
                                            <span>人民幣：{{ amountFormatte(Math.floor(goods_info.price / basic_info.WEB_RMB)) }}</span>
                                        </div>
                                        <div class="item">
                                            <span>臺幣：{{ amountFormatte(Math.floor(goods_info.price / basic_info.WEB_TAIWAN)) }}</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="right">
                                    <router-link :to="`/Login`" target="_blank">
                                        登錄查看會員折扣
                                    </router-link>
                                </div>
                            </div>
                            <div v-else class="no_login">
                                <div class="left">
                                    <div class="top"><span>₩</span>{{ amountFormatte(goods_info.price) }}</div>
                                    <div class="bottom">
                                        <div class="item">
                                            <span>人民幣：{{ amountFormatte(Math.floor(goods_info.price / basic_info.WEB_RMB)) }}</span>
                                        </div>
                                        <div class="item">
                                            <span>臺幣：{{ amountFormatte(Math.floor(goods_info.price / basic_info.WEB_TAIWAN)) }}</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="right">
                                    <div style="text-decoration:line-through">₩ {{ amountFormatte(goods_info.price) }}</div>
                                </div>
                            </div>
                        </div>
                        <div class="other_box">
                            <el-form ref="formValidate" :model="add_form" :rules="ruleValidate" label-width="80px" label-position="left">
                                <el-form-item v-for="(item, index) in goods_info.attribute_name" :key="index + 100" :label="item" size="medium" :prop="'attr.' + item">
                                    <el-radio-group v-model="add_form.attr[item]" @change="$forceUpdate()">
                                        <el-radio-button v-for="(ritem, rindex) in goods_info.attribute_value[index]" :key="rindex + 1000" :label="ritem"></el-radio-button>
                                    </el-radio-group>
                                </el-form-item>
                                <el-form-item label="購買數量" prop="num">
                                    <el-input-number v-model="add_form.num" :min="1" size="small"></el-input-number>
                                </el-form-item>
                                <el-button v-if="goods_info.status" class="common_btn" @click="Add_Shopcart()">
                                    加入購物車
                                </el-button>
                                <el-button v-else disabled class="common_btn disable_btn">
                                    該商品缺貨
                                </el-button>
                            </el-form>
                        </div>
                    </div>
                </div>
                <div v-else class="no_goods_box">
                    <img src="../../public/img/no_goods.png" />
                </div>
                <div class="detail_box">
                    <div class="detail_nav">
                        <ul>
                            <li><a href="#good_info">商品参数</a></li>
                        </ul>
                    </div>
                    <div class="con_box">
                        <div id="good_info" class="title">
                            <h1>商品参数<span>PRODUCT PARAMETERS</span></h1>
                        </div>
                        <div class="other_info_box">
                            <ul>
                                <li>
                                    <span class="td_name">
                                        商品名稱
                                    </span>
                                    <span class="td_val">
                                        {{ goods_info.name }}
                                    </span>
                                </li>
                                <li>
                                    <span class="td_name">商品品牌</span>
                                    <span class="td_val">{{ goods_info.brand_name }}</span>
                                </li>
                                <li>
                                    <span class="td_name">商品分類</span>
                                    <span class="td_val">{{ goods_info.classify_name }}</span>
                                </li>
                                <li>
                                    <span class="td_name">商品重量</span>
                                    <span class="td_val">{{ goods_info.weight }} KG/件</span>
                                </li>
                                <li>
                                    <span class="td_name">一箱數量</span>
                                    <span class="td_val">{{ goods_info.box_num }}</span>
                                </li>
                                <!-- <li>
                                    <span class="td_name">商品銷量</span>
                                    <span class="td_val">{{ goods_info.virtual_salse }}</span>
                                </li> -->
                            </ul>
                            <img :src="goods_info.image" />
                        </div>
                    </div>
                </div>
            </el-main>
        </div>
        <MainFooter />
    </div>
</template>

<script>
    import MainHeader from "@/components/Header";
    import MainNav from "@/components/MainNav";
    import MainFooter from "@/components/Footer";
    import { goods_info } from "@/api/goodsAPI";
    import { changeImage, changeAttrVal, amountFormatte } from "@/utils";
    import { add_cart } from "@/api/dataAPI";
    // 辅助函数，可以使用命名空间获取$store的数据
    import { mapState } from "vuex";
    export default {
        components: {
            MainHeader,
            MainNav,
            MainFooter,
        },
        data() {
            return {
                goods_info: [], // 商品信息
                login_status: false,
                add_form: {
                    id: null, // 商品ID
                    num: 1, // 购买数量
                    attr: {}, // 购买属性
                },
                ruleValidate: {
                    num: [
                        {
                            required: true,
                            message: "數量不能小於壹",
                            trigger: "blur",
                        },
                    ],
                },
            };
        },
        computed: {
            ...mapState("BasicInfo", ["basic_info"]),
            ...mapState("loginUser", ["user_data"]),
        },
        watch: {
            // 监控数据的变化，当某些数据变化时，需要做的事情，比如页面传递过来的ID等等
            // 可以用简单写法   '$route.params.id'(){ doSomething.. }
            "$route.query": {
                immediate: true, // 第一次的数据，也要当做是一种变化
                // 处理函数（不能修改名字） handler('新的值'，'旧的值')
                handler() {
                    this.add_form.id = this.$route.query.id ? this.$route.query.id : "";
                    if (this.add_form.id) {
                        this.get_goods_info(this.add_form.id);
                    }
                },
            },
        },
        methods: {
            amountFormatte,
            async get_goods_info(id) {
                let res = await goods_info(id);
                if (res.goods_info) {
                    this.goods_info = changeImage(400, 400, res.goods_info, "thumb")[0];
                }
                this.goods_info.attribute_name = this.goods_info.attribute_name.split("/");
                this.goods_info.attribute_value = changeAttrVal(this.goods_info.attribute_value);
                this.goods_info.attribute_value.forEach((ele, index) => {
                    this.add_form.attr[this.goods_info.attribute_name[index]] = ele[0];
                });

                // 增加校验规则
                this.goods_info.attribute_name.forEach((element, index) => {
                    this.ruleValidate["attr." + element] = [
                        {
                            required: true,
                            message: "請選擇商品屬性",
                            trigger: "blur",
                        },
                    ];
                });
            },
            Add_Shopcart() {
                if (!this.user_data) {
                    this.$router.push({ name: "Login" });
                } else {
                    this.$refs["formValidate"].validate(async (val) => {
                        if (val) {
                            // 加入购物车
                            let resp = await add_cart(this.add_form.id, this.add_form.num, this.add_form.attr);
                            switch (resp.OPStatus) {
                                case true:
                                    this.$message({
                                        type: "success",
                                        message: "商品添加成功",
                                        center: true,
                                    });
                                    break;
                                case "note":
                                    this.$message({
                                        type: "error",
                                        message: resp.msg,
                                        center: true,
                                    });
                                    break;
                                case "Login":
                                    this.$message({
                                        type: "error",
                                        message: resp.msg,
                                        center: true,
                                    });
                                    this.$router.push({ name: "Login" });
                                    break;
                                default:
                                    console.log(resp);
                                    break;
                            }
                        } else {
                            this.$message({
                                type: "error",
                                message: "請選擇商品屬性並填寫數量",
                                center: true,
                            });
                        }
                    });
                }
            },
        },
    };
</script>

<style scoped lang="scss">
    .main_box {
        width: 1240px;
        margin: 0 auto;

        .el-main {
            width: 1240px;
            padding: 0;
            background-color: #fff;

            .el-breadcrumb {
                margin: 10px 0 20px 0;
            }

            .good_con {
                width: 1000px;
                margin: 0 auto;
                height: auto;
                overflow: hidden;
                color: #999;

                .left {
                    float: left;
                    width: 400px;

                    .thum_box {
                        position: relative;
                        padding: 0;
                        width: 400px;
                        height: 500px;

                        .good_img {
                            width: 400px;
                            height: auto;
                            vertical-align: bottom;
                        }
                    }
                }

                .right {
                    float: left;
                    padding: 0 0 0 50px;
                    position: relative;
                    width: 550px;

                    .title {
                        position: relative;
                        font-size: 24px;
                        font-family: "\5FAE\8F6F\96C5\9ED1 ";
                        line-height: 1.5;
                        color: #000;
                        font-weight: 700;
                    }

                    .top_brand {
                        text-indent: -12px;
                        margin-top: 25px;
                        font-size: 20px;
                    }

                    .price_box {
                        position: relative;
                        margin: 10px auto;
                        width: 550px;
                        height: 99px;
                        color: #fff;
                        overflow: hidden;
                        background-image: url(../../public/img/price_bg.png);

                        .no_login {
                            height: 99px;

                            .left {
                                float: left;
                                width: 60%;

                                .top {
                                    height: 61px;
                                    line-height: 61px;
                                    font-size: 36px;
                                }

                                .bottom {
                                    height: 38px;
                                    line-height: 38px;

                                    .item {
                                        display: inline-block;
                                        margin-right: 20px;

                                        span {
                                            font-size: 17px;
                                        }
                                    }
                                }
                            }

                            .right {
                                float: left;
                                height: 99px;
                                line-height: 99px;
                                font-size: 18px;
                                padding: 0;
                                width: 40%;
                                text-align: center;

                                a {
                                    color: #fff;
                                }
                            }

                            span {
                                font-size: 24px;
                                padding: 0 5px 0 10px;
                            }
                        }
                    }

                    .other_box {
                        line-height: 24px;
                        font-size: 14px;
                    }

                    .tit {
                        color: #999;
                        line-height: 24px;
                        padding-right: 20px;
                        float: left;
                    }

                    .tit_con {
                        color: #525252;
                        display: inline-block;
                        height: 25px;
                        width: 305px;
                    }
                }

                .good_line {
                    font-size: 0;
                    width: 100%;
                    height: 0;
                    border-bottom: 1px dotted #c9c9c9;
                    margin: 14px 0;
                    clear: both;
                }
            }

            .detail_box {
                clear: both;
                padding-top: 20px;

                .detail_nav {
                    height: 38px;
                    width: 1238px;
                    z-index: 9;
                    border: 1px solid #ececec;
                    border-bottom-width: 2px;
                    background-color: #ff3c5c;

                    ul {
                        font-size: 14px;
                        line-height: 38px;

                        li {
                            float: left;
                            width: 90px;
                            position: relative;
                            height: 38px;
                            text-align: center;

                            a {
                                color: #fff;
                            }
                        }
                    }
                }

                .con_box {
                    padding: 15px 14px 20px 14px;
                    height: auto;
                    overflow: hidden;

                    .title {
                        height: 60px;
                        border-bottom: 1px solid #e7e7e7;
                        position: relative;
                        margin-bottom: 20px;

                        h1 {
                            height: 60px;
                            line-height: 60px;
                            font-weight: 300;
                            padding-left: 5px;
                            font-size: 22px;
                            font-family: "Hiragino Sans GB", "Microsoft Yahei";
                            color: #000;
                        }

                        span {
                            font-weight: 500;
                            color: #ccc;
                            margin-left: 20px;
                        }
                    }

                    .other_info_box {
                        ul {
                            float: left;
                            margin: 40px 0 0 140px;

                            .td_name {
                                vertical-align: top;
                                color: #343434;
                                padding: 7px;
                                font-size: 16px;
                                text-align: left;
                                font-style: normal;
                                font-weight: 400;
                                width: 70px !important;
                                display: table-cell;

                                div {
                                    width: 70px;
                                }
                            }

                            .td_val {
                                width: 300px !important;
                                color: #66666a;
                                padding: 7px;
                                font-size: 16px;
                                display: table-cell;
                            }

                            .info_img {
                                width: 330px;
                                padding-right: 110px;
                                float: right;
                                padding-top: 10px;
                                vertical-align: bottom;
                            }
                        }
                    }
                }
            }

            .no_goods_box {
                text-align: center;
                margin-top: 20px 0;

                img {
                    width: 500px;
                }
            }

            ::v-deep .el-radio-button__inner:hover {
                color: #ff3c5c;
            }

            ::v-deep .el-radio-button__orig-radio:checked + .el-radio-button__inner {
                background-color: #ff3c5c;
                border-color: #ff3c5c;
                box-shadow: -1px 0 0 0 #ff3c5c;
            }

            ::v-deep .el-radio-button__orig-radio:checked + .el-radio-button__inner:hover {
                color: #fff;
            }

            button.common_btn {
                width: 176px;
                height: 45px;
                font-size: 16px;
            }

            button.disable_btn {
                border-color: #e7eaf1;
            }
        }
    }
</style>
